module.exports = __webpack_public_path__ + "img/vexPolar.a459a534.svg";